import Vue from "vue";
import VueRouter from "vue-router";
import { loginRoutes } from "@/app/login";

import { logisticVariantRoutes } from "@/app/logisticVariant";
import { PageNotFound } from "@/app/shared/components";
import { PageUnauthorized } from "@/app/shared/components";

import store from "@/app/app-state";

Vue.use(VueRouter);

const appRoutes = [
  {
    path: "/",
    redirect: "/logisticVariant/logisticVariant"
  },
  {
    path: "*",
    name: "page-not-found",
    component: PageNotFound,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: "/Unauthorized",
    name: "page-unauthorized",
    component: PageUnauthorized,
    meta: {
      allowAnonymous: true
    }
  }
];

const routes = [...loginRoutes, ...appRoutes, ...logisticVariantRoutes];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, _from, next) => {
  // appel de la mise a jour du token et des droits dans le state

  let isAuthenticated = store.getters["userContext/isAuthenticated"];

  if (to.matched.some(record => record.meta.allowAnonymous)) {
    if (to.name == "login" && isAuthenticated) {
      let urlredirect = "/";
      if (to.query.redirectUri != undefined) {
        urlredirect = to.query.redirectUri;
      }
      next({ path: urlredirect });
    } else {
      next();
    }
  } else {
    if (isAuthenticated) {
      //TODO : voir si ca a du sens
      // if (isAuthorized) {
      next();
      // } else {
      //   next("/Unauthorized", { replace: true, name: "page-unauthorized" });
      // }
    } else {
      // redirection vers la page de login
      const redirectUri = to.fullPath;
      next({ name: "login", query: { redirectUri: redirectUri } });
    }
  }
});

export default router;
